import * as Sentry from '@sentry/react';

/** No-op unless VITE_SENTRY_DSN is set at build time. */
export function initSentry(): void {
  const dsn = import.meta.env.VITE_SENTRY_DSN as string | undefined;
  if (!dsn) return;
  Sentry.init({ dsn, environment: import.meta.env.MODE, tracesSampleRate: 0.1 });
}

export function reportError(error: unknown, extra?: Record<string, unknown>): void {
  Sentry.captureException(error, extra ? { extra } : undefined);
}
